import React, {forwardRef} from "react";
import {makeStyles} from "@material-ui/core/styles";
import PropTypes from "prop-types";
import NumberFormat from "react-number-format";
import TextField from "@material-ui/core/TextField";
import {Input} from ".";
import {FormControl, InputAdornment, IconButton} from "@material-ui/core";
import Visibility from "@material-ui/icons/Visibility";
import VisibilityOff from "@material-ui/icons/VisibilityOff";
import {createIcon} from "../common";
import SubdirectoryArrowLeftIcon from "@material-ui/icons/SubdirectoryArrowLeft";
import Tooltip from "../Tooltip";
import { helpStyle } from "./common";
import { equals, invalid } from "@codeArt/utils/common";

function FloatFormat(props){
  const {inputRef, onChange, ...other} = props;

  return (
    <NumberFormat
      {...other}
      getInputRef={inputRef}
      onValueChange={values => {
        onChange({
          target: {
            value: values.value
          }
        });
      }}
      thousandSeparator={false}
      isNumericString
    />
  );
}

FloatFormat.propTypes = {
  inputRef: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired
};

function IntFormat(props){
  const {inputRef, onChange, ...other} = props;
  return (
    <NumberFormat
      {...other}
      getInputRef={inputRef}
      onValueChange={values => {
        onChange({
          target: {
            value: values.value
          }
        });
      }}
      decimalScale={0}
      thousandSeparator={false}
      isNumericString
    />
  );
}

IntFormat.propTypes = {
  inputRef: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired
};

export class TextBox extends Input {
  constructor(props) {
    super(props);
    this.state = {
      ...this.state
    };
  }

   
  handleChange(v){
    super.handleChange(v);
    let newValue = v;
    let oldValue = this.props.value;
    this.__changed = equals(oldValue, newValue);
  }

  shouldComponentUpdate(nextProps, nextState) {
    if(this.__changed) {
      this.__changed = false;
      return true;
    }

    // let newValue = nextProps.value;
    // let oldValue = this.props.value;
    // if (!equals(oldValue, newValue)) return true;

    //因为end可能发生变化，所以单纯的判断value不足以体现变化，就直接把整个属性对象进行对比
    if (!equals(nextProps, this.props)) return true;

    return false;
  }

  ignore(b) {
    //忽略项，这个方法会将组件隐藏，并且不参与form行为
    // var o = this, oj = this.getJquery();
    // if (b) {
    //     o.ignoreForm = true;
    //     oj.hide();
    // } else {
    //     o.ignoreForm = false;
    //     oj.show();
    // }
  }

  handleBlur(v) {
    let {onBlur} = this.props;
    this.validate();
    if (onBlur) onBlur(v);
  }

  handleFocus(v) {
    let {onFocus} = this.props;
    if (onFocus) onFocus(v);
  }

  defaultErrorMessage(type) {
    let {minlength, maxlength} = this.props;
    let call = this.call();
    switch (type) {
      case "minlength": {
        return `${call}字数不能小于${minlength}`;
      }
      case "maxlength": {
        return `${call}字数不能大于${maxlength}`;
      }
      case "variable": {
        return `${call}只能包含英文、数字和下划线`;
      }
      default:
    }
    return super.defaultErrorMessage(type);
  }

  getInputProps() {
    let p = super.getInputProps();
    let {type, rowsMax, variant} = this.props;
    if (type === "float") {
      p.inputComponent = FloatFormat;
    } else if (type === "int") {
      p.inputComponent = IntFormat;
    } else if (rowsMax > 1 && variant === "standard") {
      p.endAdornment = (
        <InputAdornment position="end">
          {createIcon(SubdirectoryArrowLeftIcon, "c-text-s3 m-text-dark-50")}
        </InputAdornment>
      );
    }

    if(this.readOnly()){
      p.readOnly = true;
    }

    return p;
  }

  getInputType() {
    let {type} = this.props;
    switch (type) {
      case "hidden":
        return "hidden";
      case "text":
        return "text";
      default:
    }
    return type;
  }

  getAutoComplete() {
    let {autoComplete} = this.props;
    if (autoComplete === false) return "new-password";
    return "on";
  }

  getReceiveFocus() {
    //获得用于接收焦点的组件
    return this.input.getElementsByTagName("input")[0];
  }

  renderInput({className,value}) {
    let {
      label,
      placeholder,
      help,
      rowsMax,
      required,
      variant,
      rows,
      full,
      autoComplete,
      size,
      width,
      margin
    } = this.props;
    let {error} = this.state;
    let inputType = this.getInputType();
    let style = width ? {width} : {};

    return (
      <TextFieldWrapper
        style={{...style}}
        ref={r => {
          this.input = r;
        }}
        autoComplete={this.getAutoComplete()}
        required={required ? true : false}
        variant={variant}
        key={"textbox"}
        className={className}
        error={error ? true : false}
        size={size}
        type={inputType}
        disabled={this.disabled()}
        placeholder={placeholder}
        helperText={error || help}
        label={label}
        multiline={(rowsMax > 1 || rows > 1) ? true : false}
        minRows={rows}
        maxRows={rowsMax || rows || 1}
        margin={margin}
        value={!invalid(value) ? value : (invalid(this.get()) ? "" : this.get())}
        InputLabelProps={{
          shrink: true
        }}
        InputProps={this.getInputProps()}
        onChange={e => {
          this.handleChange(e.target.value);
        }}
        onBlur={e => {
          this.handleBlur(e.target.value);
        }}
        onFocus={e => {
          this.handleFocus(e.target.value);
        }}
        onClick={e => {
          if(this.handleClick) this.handleClick(e);
        }}
        full={full}
        fullWidth
      />
    );
  }

  renderMain(title, className, width) {
    return title ? (
      <FormControl className={`${width ? "" : "w-100"} ${className}`}>
        {[ title, this.renderInput({className:""}) ]}
      </FormControl>
    ) : (
      this.renderInput({className})
    );
  }

  render() {
    let {type, full, width} = this.props; //full=true表示textbox不用自动伸展，已经是满的状态
    let className = this.getClassName(
      type === "hidden" ? "c-input-hidden" : ""
    );
    let title = this.tipComponent("textBox", {ignore: true}, 0);
    className = `${full ? "c-input-full c-flex-1" : ""} ${className} `;
    let tip = this.getTip();
    if (!tip) {
      return this.renderMain(title, className, width);
    }
    return Tooltip({
      description: tip,
      placement: "top",
      content: (
        <div className={`${width ? "" : "w-100"}`}>
          {this.renderMain(title, className, width)}
        </div>
      )
    });
  }
}

TextBox.defaultProps = {
  type: "text",
  variant: "outlined", //"standard",
  size: "medium",
  rows: null,
  className: "",
  autoComplete: true,
  width: 0,
  margin: "normal",
  full: false
};

TextBox.searchBarProps = {
  size: "small",
  margin: "none",
  className: "c-mb-0",
  full: false
};

const useStyles = makeStyles(theme => ({
  textField: ({full}) => ({
    "& .MuiInputLabel-outlined.MuiInputLabel-shrink": {
      transform: "translate(14px, -8px) scale(0.9)"
    },
    "& .MuiFormHelperText-contained": {
     ...helpStyle
    },
    "& .MuiInputBase-multiline.MuiOutlinedInput-multiline": {
      height: full === true ? "100%!important" : ""
    },
    "& .MuiInputBase-multiline.MuiOutlinedInput-multiline textarea": {
      height: full === true ? "100%!important" : ""
    }
  })
}));

const TextFieldWrapper = forwardRef((props, ref) => {
  const classes = useStyles({full: props.full});
  const className = props.className || "";
  let ps = {...props};
  delete ps.full;
  return (
    <TextField
      {...ps}
      ref={ref}
      className={`${classes.textField} ${className}`}
    />
  );
});

export class Password extends TextBox {
  constructor(props) {
    super(props);
    this.state = {
      ...this.state,
      showPassword: false
    };
  }

  getInputType() {
    let {showPassword} = this.state;
    return showPassword ? "text" : "password";
  }

  getInputProps() {
    let p = super.getInputProps();
    p.endAdornment = this.getPasswordAdornment();
    return p;
  }

  handleClickShowPassword() {
    let {showPassword} = this.state;
    this.setState({
      showPassword: !showPassword
    });
  }

  handleMouseDownPassword(e) {
    e.preventDefault();
  }

  getPasswordAdornment() {
    let {showPassword} = this.state;
    return (
      <InputAdornment position="end">
        <IconButton
          aria-label="toggle password visibility"
          onClick={() => {
            this.handleClickShowPassword();
          }}
          onMouseDown={e => {
            this.handleMouseDownPassword(e);
          }}
        >
          {showPassword ? <Visibility /> : <VisibilityOff />}
        </IconButton>
      </InputAdornment>
    );
  }
}
